import { isFuture, isPast } from 'date-fns';
import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';
import { nullableDate } from '../utils/format.ts';

export class Exam extends Model<Schemas['exams'], Models> {
    get opensAtDate() {
        return nullableDate(this.opensAt);
    }

    get closesAtDate() {
        return nullableDate(this.closesAt);
    }

    get isOpen() {
        return (
            (!this.opensAtDate && !this.closesAtDate) ||
            ((!this.opensAtDate || isPast(this.opensAtDate)) &&
                (!this.closesAtDate || isFuture(this.closesAtDate)))
        );
    }
}
